var CanvasUtils;
((CanvasUtils2) => {
  let Context2D;
  ((Context2D2) => {
    Context2D2.resetTransform = (context) => {
      context.setTransform(1, 0, 0, 1, 0, 0);
    };
  })(Context2D = CanvasUtils2.Context2D || (CanvasUtils2.Context2D = {}));
  CanvasUtils2.fontSize = (ctx, config) => {
    const { text, maxWidth, maxHeight, fontOption } = config;
    if (!text || maxWidth <= 0 || maxHeight <= 0) {
      return 0;
    }
    const lines = text.split("\n").filter((line) => line.trim().length > 0);
    if (lines.length === 0) {
      return 0;
    }
    const lineHeightMultiplier = 1.2;
    const maxFontSizeByHeight = Math.floor(maxHeight / (lines.length * lineHeightMultiplier));
    if (maxFontSizeByHeight <= 0) {
      return 0;
    }
    let minSizeForWidth = 1;
    let maxSizeForWidth = maxFontSizeByHeight;
    let bestSizeForWidth = 0;
    const maxIterations = 100;
    let iteration = 0;
    while (minSizeForWidth <= maxSizeForWidth && iteration < maxIterations) {
      const midSize = Math.floor((minSizeForWidth + maxSizeForWidth) / 2);
      if (midSize === 0) break;
      ctx.font = `${fontOption?.fontWeight || "normal"} ${midSize}px ${fontOption?.fontFamily || "sans-serif"}`;
      const maxLineWidth = Math.max(...lines.map((line) => ctx.measureText(line).width));
      if (maxLineWidth <= maxWidth) {
        bestSizeForWidth = midSize;
        minSizeForWidth = midSize + 1;
      } else {
        maxSizeForWidth = midSize - 1;
      }
      iteration++;
    }
    return Math.min(bestSizeForWidth, maxFontSizeByHeight);
  };
  CanvasUtils2.textMetrics = (context, text) => {
    return context.measureText(text);
  };
})(CanvasUtils || (CanvasUtils = {}));
export {
  CanvasUtils
};
//# sourceMappingURL=CanvasUtils.js.map
